import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getEntrepreneurshipByApplicationId(
  applicationId: string
) {
  return await prisma.applicantEntrepreneurship.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
